import { createFileRoute } from "@tanstack/react-router";
import { BookingProvider } from "@/components/site/booking-context";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { MobileBookingBar } from "@/components/site/MobileBookingBar";
import {
  NearbyHero,
  NearbyIntro,
  FeaturedOutdoors,
  DestinationExplorer,
  PerfectDay,
  GoldCountryStory,
  OutdoorAdventureStory,
  LocalFlavor,
  StayLonger,
  NearbyMidCTA,
  NearbyFAQ,
  NearbyCTA,
} from "@/components/site/nearby-attractions";
import { heroPreloadLink } from "@/data/optimized-images";
import { destinationFaqs, resort } from "@/data/resort";
import { absoluteUrl } from "@/lib/site";
import heroMainAsset from "@/assets/auburn-hero-main.webp.asset.json";


const title = "Things to Do Near Auburn, CA | Auburn RV Resort & Sierra Foothills Guide";
const description =
  "Discover things to do near Auburn RV Resort, from American River adventures and Sierra Foothills trails to California Gold Country, wineries, historic towns and Lake Tahoe day trips.";
const ogImage = `https://auburnrvresort.com${heroMainAsset.url}`;


const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": ["LodgingBusiness", "Campground"],
      name: resort.name,
      description,
      telephone: resort.phone,
      email: resort.email,
      url: "/nearby-attractions/",
      address: {
        "@type": "PostalAddress",
        streetAddress: resort.address.street,
        addressLocality: resort.address.city,
        addressRegion: resort.address.state,
        postalCode: resort.address.zip,
        addressCountry: "US",
      },
    },
    {
      "@type": "FAQPage",
      mainEntity: destinationFaqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};

export const Route = createFileRoute("/nearby-attractions")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:image", content: ogImage },
      { property: "og:image:width", content: "1322" },
      { property: "og:image:height", content: "936" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: ogImage },
    ],
    links: [{ rel: "canonical", href: absoluteUrl("/nearby-attractions/") }, heroPreloadLink],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(schema) }],
  }),
  component: NearbyAttractionsPage,
});

function NearbyAttractionsPage() {
  return (
    <BookingProvider>
      <Navbar />
      <main>
        <NearbyHero />
        <NearbyIntro />
        <FeaturedOutdoors />
        <DestinationExplorer />
        <PerfectDay />
        <GoldCountryStory />
        <OutdoorAdventureStory />
        <LocalFlavor />
        <StayLonger />
        <NearbyMidCTA />
        <NearbyFAQ />
        <NearbyCTA />
      </main>
      <Footer />
      <MobileBookingBar />
    </BookingProvider>
  );
}
